import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

constructor( private http: HttpClient, private router: Router ) { }

resultsFromAuthService;

login(username: string, password: string) {
  const endpoint = 'https://apps.pacmedservices.com/fmi/data/v1/databases/DxSearch/sessions';
  const auth = 'Basic ' + btoa(username + ':' + password);
  const body = '{}';
  // console.log(auth);

  return this.http.post(endpoint, body, {
    headers: new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Access-Control-Allow-Origin', '*')
      .set('Authorization', auth)
  });
}

logout() {
  localStorage.removeItem('dxtoken');
  this.router.navigate(['login']);
}

isLoggedIn() {
  const dxtoken = localStorage.getItem('dxtoken');

  if (!dxtoken) {
    return false;
  }

  return true;
}

}
